import imgCard1 from '../../assets/images/cards/box-card1.png';
import imgCard2 from '../../assets/images/cards/box-card2.png';
import imgCard3 from '../../assets/images/cards/box-card3.png';
import imgCard4 from '../../assets/images/cards/box-card4.png';

import imgCard1Silver from '../../assets/images/cards/freya-silver.png';
import imgCard2Silver from '../../assets/images/cards/heimdall-silver.png';
import imgCard3Silver from '../../assets/images/cards/Thor-silver.png';
import imgCard4Silver from '../../assets/images/cards/odin-silver.png';

export const getSelectedNode = (currentCard) => {
  switch (currentCard) {
    case 1:
      return { img: imgCard2, hoverImg: imgCard2Silver, name: 'HEIMDALL', cost: 1.25, rewards: 0.008 };
    case 2:
      return { img: imgCard1, hoverImg: imgCard1Silver, name: 'FREYA', cost: 6.25, rewards: 0.05 };
    case 3:
      return { img: imgCard3, hoverImg: imgCard3Silver, name: 'THOR', cost: 12.5, rewards: 0.144 };
    case 4:
      return { img: imgCard4, hoverImg: imgCard4Silver, name: 'ODIN', cost: 78.125, rewards: 1.02 };
    default:
      return { img: imgCard1, hoverImg: imgCard1Silver, name: 'FREYA', cost: 6.25, rewards: 0.05 };
  }
};
